import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Alert, AlertTitle, Button, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function DisconnectedConnectionAlert() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const connections = useSelector(
    (state) => state.connectionReducer.connections
  );

  // Don't show the banner on the /oops page
  if (location.pathname === "/oops") {
    return null;
  }

  // Check if any connection is disconnected
  const hasDisconnectedConnection = connections?.some(
    (connection) => connection.connectionStatus === "disconnected"
  );

  if (!hasDisconnectedConnection) {
    return null;
  }

  return (
    <Box maxWidth="lg" sx={{ mx: "auto", mb: 2 }}>
      <Alert
        severity="error"
        sx={{ mb: 2 }}
        action={
          <Button
            variant="outlined"
            color=""
            size="small"
            onClick={() => navigate("/calendars")}
          >
            Reconnect
          </Button>
        }
      >
        One of your calendar connections is disconnected. Please reconnect to
        continue syncing events and tracking time.
      </Alert>
    </Box>
  );
}
